import { gql } from "@apollo/client"
import { Position } from "@blueprintjs/core"
import { TimePrecision } from "@blueprintjs/datetime"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import CustomDateInput from "components/Atoms/CustomDateInput"
import CustomDatePicker from "components/Atoms/CustomDatePicker"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import StringInput from "components/Atoms/StringInput"
import { withFormController } from "components/Molecules/FormController"
import SearchMultiSelector from "components/Templates/SearchMultiSelector"
import SearchSelector from "components/Templates/SearchSelector"
import React from "react"
// DATE
// Date

// DATM
// Date Time

// NUMB
// Number

// TEXT
// Text

// BOOL
// Boolean

// RELN
// Relation

// ARRY
// Array of Items
const DynamicValue = ({ item, path, onChange, className }) => {
  const props = {
    path,
    big: false,
    onChange,
    className,
  }
  switch (item?.fieldType) {
    case "TEXT":
      return <StringInput label="Text" {...props} />
    case "NUMB":
      return <StringInput label="Number" type="number" {...props} />
    case "DATE":
      return (
        <CustomDateInput
          popoverProps={{
            popoverClassName: "absolute",
            minimal: true,
            position: Position.BOTTOM_LEFT,
          }}
          label="Date"
          {...props}
        />
      )
    case "BOOL":
      return (
        <CustomFormGroup label="True / False">
          <CustomCheckbox {...props} />
        </CustomFormGroup>
      )
    case "DATM":
      return (
        <CustomFormGroup label="Date Time" className={props?.className}>
          <CustomDatePicker
            fill
            format="MMMM Do YYYY, h:mm:ss A"
            valueAs="object"
            popoverProps={{
              minimal: true,
              position: Position.BOTTOM_LEFT,
              popoverClassName: "absolute",
            }}
            closeOnSelect={false}
            timePickerProps={{
              useAmPm: true,
              showArrowButtons: true,
              precision: TimePrecision.SECOND,
            }}
            path={props?.path}
            onChange={props?.onChange}
          />
        </CustomFormGroup>
      )
    case "RELN":
      return (
        <SearchSelector
          label="Related To"
          query={gql(item?.referenceQuery)}
          {...props}
        />
      )
    case "ARRY":
      return (
        <SearchMultiSelector
          fill
          label="Items"
          query={gql(item?.referenceQuery)}
          {...props}
        />
      )
    default:
      return null
  }
}

export default withFormController(DynamicValue)
